import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Typography } from "antd";
import { bindActionCreators } from "redux";

import EditInspectors from "./EditInspectors";
import { PlusOutlined } from "@ant-design/icons";
import DataTable from "../../../../Components/DataTable";
import * as userActions from "../../../../actionCreators/User";
import * as propertyActions from "../../../../actionCreators/Property";

import "./style/inspectorsListing.css";

const Inspectors = ({ users, getTaxInspectors, getCircles }) => {
  const [data, setData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [openEditInspector, setOpenEditInspector] = React.useState(false);

  React.useEffect(() => {
    getTaxInspectors({ page: 0, pageSize: 10 });
    getCircles();
  }, []);

  React.useEffect(() => {
    if (users.data) {
      setData(users.data);
      setPagination(users.pagination);
      setLoading(users.loading);
    }
  }, [users]);

  const handleTablePageChange = (tableChangeData) => {
    const { current, pageSize } = tableChangeData;
    getTaxInspectors({ page: current - 1, pageSize });
  };

  const tableColumns = [
    {
      title: "Name",
      dataIndex: "full_name",
      sorter: false,
      width: "20%",
    },
    {
      title: "Circle",
      dataIndex: "name",
      width: "15%",
      render: (name) => (name ? name : "---"),
    },
    // {
    //   title: "Highway Name",
    //   dataIndex: "highway",
    //   width: "15%",
    //   render: (highway) => (highway ? highway.name : "---"),
    // },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Account Status",
      dataIndex: "disabled",
      filters: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      onFilter: (data, row) => {
        if (row?.disabled === false && data === "active") {
          return true;
        } else if (row?.disabled === true && data === "inactive") {
          return true;
        }
      },
      render: (disabled) =>
        disabled ? (
          <span style={{ color: "red" }}>Inactive</span>
        ) : (
          <span style={{ color: "green" }}>Active</span>
        ),
    },
  ];

  const onTableRowClick = (data) => {
    setRowData(data);
    setOpenEditInspector(true);
  };

  return (
    <div>
      <div className="header">
        <Typography className="heading">
          Inspectors {pagination.count ? `(${pagination.count})` : null}
        </Typography>
      </div>
      <div>
        {!openEditInspector && (
          <DataTable
            rowClassName="table-row-cursor-pointer"
            columns={tableColumns}
            pagination={pagination}
            loading={loading}
            data={data}
            handleTableValuesChange={handleTablePageChange}
            onRowClick={onTableRowClick}
          />
        )}
        {openEditInspector && (
          <EditInspectors
            closeEditInspectors={() => setOpenEditInspector(false)}
            rowData={rowData}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ user: { users } }) => ({ users });

const mapDispatchToProps = (dispatch) => ({
  getTaxInspectors: bindActionCreators(userActions.getTaxInspectors, dispatch),
  getCircles: bindActionCreators(propertyActions.getCircles, dispatch),
});

Inspectors.propTypes = {
  users: PropTypes.object.isRequired,
  getTaxInspectors: PropTypes.func.isRequired,
  getCircles: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Inspectors);
